import React, { useEffect, useState } from 'react';
import { StandardButton } from '../../common/GlobalElements/StandardButton';
import { LabelMedium, TextLink } from '../../common/GlobalElements/Typography';
import ButtonGroup from '../../ui/ButtonGroup';

export default function DownloadCertificate({ item, canRemove, handleRemoveFile, canEdit, handleFileEdit }) {
    const [fileName, setFileName] = useState(null);
    useEffect(() => {
        const fileSplitArray = item.url.split('/');
        const fileDisplayName = fileSplitArray[fileSplitArray.length - 1];
        setFileName(fileDisplayName);
    }, [item]);

    return (
        <>
            <TextLink className="profile-file-name" href={item.file} target="_blank" title={fileName}>
                <i className="fal fa-file"></i> {fileName}
            </TextLink>
            <ButtonGroup flexWrap={false} marginTop={0}>
                {canEdit ? (
                    <StandardButton type="button" className="atttach-file" isRounded={true} gap>
                        <LabelMedium>
                            <i className="fal fa-paperclip"></i>
                            <input
                                type="file"
                                className="form-control-aatch-file"
                                onChange={(e) => handleFileEdit(e)}
                            />
                        </LabelMedium>
                    </StandardButton>
                ) : null}
                {canRemove ? (
                    <StandardButton
                        type="button"
                        variant="danger"
                        isRounded={true}
                        onClick={() => handleRemoveFile(item.id)}
                        title="Remove Certificate"
                    >
                        <i className="fal fa-trash-alt"></i>
                    </StandardButton>
                ) : null}
            </ButtonGroup>
        </>
    );
}
